<div class="p-fluid p-formgrid p-grid">
  <div class="p-col-12 p-lg-3">
    <p-card header="Filtros" (keyup)="ds.onEnterPesquisar($event)">
      <div class="p-grid">
        <m-restricao-number label="Id"[restricao]="ds.restricoes.atributo('id')"></m-restricao-number>
        <m-restricao-string label="Fonte de dados"[restricao]="ds.restricoes.atributo('fonteDados.nome')"></m-restricao-string>
        <m-restricao-string label="Origem Id"[restricao]="ds.restricoes.atributo('origemId')"></m-restricao-string>
        <m-restricao-string label="Nome"[restricao]="ds.restricoes.atributo('nome')"></m-restricao-string>
        <m-restricao-string label="Órgão julgador"[restricao]="ds.restricoes.atributo('orgaoJulgador.nome')"></m-restricao-string>
        <m-restricao-string label="Órgão de Justiça (sigla)"[restricao]="ds.restricoes.atributo('orgaoJulgador.orgaoJustica.sigla')"></m-restricao-string>
        <m-restricao-entidade label="Situação"
                              [restricao]="ds.restricoes.atributo('situacao')"
                              [itens]="orgaoJulgadorLocalSituacaoItens"
                              itemId="value"
                              itemLabel="label">
        </m-restricao-entidade>
      </div>
      <p-footer>
        <div class="p-fluid p-grid">
          <div class="p-field p-col">
            <button pButton label="Pesquisar" (click)="ds.pesquisar()"></button>
          </div>
          <div class="p-field p-col">
            <button pButton class="p-button-secondary" label="Limpar" (click)="ds.limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>

  <div class="p-col-12 p-lg-9">
    <p-card header="Lista de órgãos de julgadores locais">
      <p-table
        [multiSortMeta]="ds.ordenacoes"
        [value]="ds.entidades"
        [totalRecords]="ds.total"
        (onLazyLoad)="ds.carregar($event)"
        [lazy]="true"
        [(rows)]="ds.registros"
        [paginator]="true"
        responsive="true"
        sortMode="multiple"
        responsiveLayout="scroll"
        styleClass="p-datatable-striped"
        emptyMessage="Nenhum registro encontrado">

        <ng-template pTemplate="header">
          <tr>
            <th class="p-text-center" style="width: 150px;"> <app-rotulo></app-rotulo></th>
            <th pSortableColumn="origemId" style="width: 180px">Origem<p-sortIcon field="origemId"></p-sortIcon></th>
            <th pSortableColumn="orgaoJulgador">Orgão Julgador <p-sortIcon field="orgaoJulgador"></p-sortIcon></th>
            <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
            <th pSortableColumn="situacao" style="width: 180px" class="p-text-center">Situação<p-sortIcon field="situacao"></p-sortIcon></th>
            <th class="p-text-center" style="width: 120px">Ação</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-entity>
          <tr>
            <td class="p-text-center">
              <app-id
                [id]="entity.id"
                [origemId]="entity.origemId">
              </app-id>
            </td>
            <td class="text-left">{{entity.fonteDados?.nome}}</td>
            <td class="text-left">{{entity.orgaoJulgador?.nome}}
              <br><span style="font-size: 0.8em; font-style: italic">{{entity?.orgaoJulgador?.orgaoJustica?.sigla}}</span>
            </td>
            <td class="text-left">{{entity.nome}}</td>
            <td class="p-text-center">
              <span [ngClass]="entity.situacao === 'ATIVO' ? 'badge badge-success' : 'badge badge-gray'">
                {{entity.situacao  | dominio:'getSituacaoItens'}}
              </span>
            </td>
            <td class="p-text-center">
              <a
                pButton
                type="button"
                class="p-button-sm p-m-r-2"
                (click)="dlgOrgaoJulgadorLocal.showDialog(entity)"
                pButton icon="pi pi-pencil"
                pTooltip="Editar" >
              </a>
              <a
                pButton [routerLink]="['/orgaoJulgadorLocal/visualizar/', entity.id]"
                class="p-button-sm p-m-r-2"
                icon="pi pi-search"
                pTooltip="Visualizar">
              </a>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="summary">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-6" *ngIf="fonteDados">
              <button pButton (click)="sincronizar()" class="p-primary" label="Sincronizar *"></button>
            </div>
            <div class="p-field p-col-6 p-text-right">
              Quantidade de registros: <span class="p-text-bold"> {{ds.total}}</span>
            </div>
          </div>
          <div class="p-fluid p-formgrid p-grid" *ngIf="fonteDados">
            <div class="p-col-12">
              <div class="p-grid m-l-8">
                <p>* Ao sincronizar os orgão julgadores locais serão aplicadas as seguintes regras negociais:</p>
                <ul>
                  <li>Caso o orgão julgador esteja como <b>inconsistente</b> o sistema irá atualizar com a informação fornecida pela fonte de dados;</li>
                  <li>Caso o orgão julgador já esteja atribuído, o sistema irá ignorar a informação sobre o orgão julgador fornecida pela fonte de dados;</li>
                  <li>Em ambos os casos o sistema irá atualizar o nome do orgão julgador local com a informação fornecida pela fonte de dados.</li>
                </ul>
              </div>
            </div>
          </div>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>

<app-orgao-julgador-local-edicao
  #dlgOrgaoJulgadorLocal
  (onSalvar)="onSalvarOrgaoJulgadorLocal()">
</app-orgao-julgador-local-edicao>
